import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const allowedBaseUrls = ['/hjalp/vejledninger']
let mode = 'history'
let base = allowedBaseUrls.find(x => location.pathname.startsWith(x)) || '/'

// Opened on a CDN from a index.html file
const staticPath = '/cs/oister-dk'
if (location.pathname.indexOf(staticPath + '/index.html') !== -1) {
  mode = 'abstract'
  base = staticPath + '/index.html'
}

let router = new VueRouter({
  mode: 'history',
  base,
  routes: [
    {
      name: 'device-selector',
      path: '/:brand?',
      component: () => import('@/pages/device-selector'),
    },
    {
      name: 'device',
      path: '/:brand/:model',
      component: () => import('@/pages/device'),
      children: [
        {
          name: 'device.section',
          path: ':section?',
          component: () => import('@/pages/device-section'),
        },
        {
          name: 'device.topic',
          path: ':section/:topic',
          component: () => import('@/pages/device-topic'),
        },
      ],
    },
    {
      name: 'not-found',
      path: '*',
      component: () => import('@/pages/page-not-found'),
    },
  ],
})

export default router
